// src/Marquee.js

import React, {useEffect, useCallback} from 'react';
import './NewsFeed.css';
import { useNavigate } from 'react-router-dom';
import { setNews } from '../pages/slices/newsFeederSlicer';
import { useDispatch, useSelector } from 'react-redux';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';
import axios from 'axios';
// import btcIcon from './btc-icon.png'; // Add your BTC icon in the src directory

const NewsFeed = () => {
    const dispatch = useDispatch();
    const { news } = useSelector(state => state.newsFeeder);
    const newsArray = Array.isArray(news) ? news : [];
    const extendedNews = [...newsArray, ...newsArray];    
    const navigate = useNavigate();    

    const handleRedirect = (idx) => {        
        navigate(`/News/${idx}`);
    };

    const refreshTokenIfNeeded = useCallback(async () => {
        if (isTokenExpired()) {        
          await handleLogin();
        }    
      },[]);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                await refreshTokenIfNeeded();
                          
                const response = await axios.get('https://min-api.cryptocompare.com/data/v2/news/?lang=EN', {
                    method: 'GET',
                    headers: {                        
                        'Content-Type': 'application/json',
                        'authorization': `Apikey ${process.env.REACT_APP_CRYPTOCOMPARE_API_KEY}`
                    }
                });
                dispatch(setNews(response.data.Data));
            } catch (error) {
                console.error('Error fetching the news:', error);
            }
        };

        fetchNews();
    }, [dispatch, refreshTokenIfNeeded]);

    return (
        <div className="marquee-container">
            <div className="marquee">
                {extendedNews.map((item, index) => (
                    <div className="marquee-item" key={index}>
                        {/* <img src={item.source_info.img} alt="img" className="img-prop" /> */}
                        <div style={{
                            width: '10px',
                            height: '10px',
                            borderRadius: '50%',
                            backgroundColor: 'white' // Change to your desired color
                        }}></div>&nbsp;
                        <span
                            className='link_news'
                            onClick={() => handleRedirect(item.id)}
                            style={{ textDecoration: 'none', cursor: 'pointer' }}
                        >
                            {item.title}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default NewsFeed;
